import React from "react"

import styled from "styled-components/native"

import Text, { TextColor } from "./text"
import Touchable, { TouchableProps } from "./touchable"

const StyledTouchable = styled(Touchable)`
  display: flex;
  justify-content: center;
  height: ${(props) => props.theme.button.height.medium}px;
`

export function PlainSettingsButton({
  color,
  children,
  ...touchableProps
}: TouchableProps & { color?: TextColor }) {
  return (
    <StyledTouchable feedback="opacity" {...touchableProps}>
      <Text textStyle="button" color={color}>
        {children}
      </Text>
    </StyledTouchable>
  )
}
